import { defineSlotRecipe } from '@chakra-ui/react'

export const continueButton = defineSlotRecipe({
  className: 'ContinueButton',
  slots: ['container', 'continueButton'],
  base: {
    container: {
      display: 'flex',
      borderRadius: '1rem',
      alignSelf: 'stretch',
    },
    continueButton: {
      gap: '1rem',
      width: '100%',
      _focus: {
        outline: 'brand.focusOutline',
      },
    },
  },
})
